import React, { useContext, useReducer, useState,useEffect } from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import {
  Footer,
  Button,
  Checkbox,
  Layout,
  Input,
  InfoBox
} from 'components';

import '../profile-general.less';
import './iplist.less';

import { Table, Tabs, Tooltip, Form, Modal, message } from 'antd';

import DeleteIcon from 'assests/icons/delete.icon';
import RightChevronIcon from 'assests/icons/right-chevron.icon';
import CheckIcon from 'assests/icons/check';
import UserWomen from 'assests/icons/user-women.icon';
import InfoBorder from 'assests/icons/info-border.icon';

import { DimensionsContext } from 'context/dimensions.context';
import ProfileMenu from '../profilemenu';
import { useSelector } from 'react-redux';
import {getIpList,removeIp, addIp}  from 'services/msisdn.service';
import { customMessages } from 'utils';

const { TabPane } = Tabs;

const IpList = () => {
  const auth = useSelector(state => state.auth);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [newPermissionModal, setNewPermissionModal] = useState(false);
  const [editPermissionModal, setEditPermissionModal] = useState(false);
  const { isTabletBig, isScreenLG } = useContext(DimensionsContext);

  const [isAuthorized, setIsAuth] = useState(true);
  const [form] = Form.useForm();

  const columns = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setSelectedItems(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setSelectedItems([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setSelectedItems((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setSelectedItems(
                      selectedItems.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: '',
      align:'left',
      children: [
        {
          title: 'IP',
          align:'left',
          dataIndex: 'ip',
        },
      ],
    },{
      title: '',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {selectedItems.length > 0 ? (
                <div className="group-actions">
                  <button
                  onClick={() => {
                    OnRemoveIp(selectedItems.map((item)=> item.ip));
                  }}  >
                    <DeleteIcon />
                    Sil
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'lastLogin',
          render: (text,record) => (
            <>
              <div className="row-edit">
                <button
                  onClick={() => {
                    OnRemoveIp([record.ip]);
                  }}
                >
                  Sil<RightChevronIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
 
  const [arrayList, setArrayList] = useState([]);

  function OnRemoveIp(data) {
    removeIp({ ips :data })
      .then((result) => {
        fetchData();
        form.resetFields();
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function OnAddIp(data) {
    addIp({ ipAdress :data })
      .then((result) => {  
        fetchData();
        form.resetFields();
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function fetchData() {
    getIpList()
      .then((result) => {
       var newData = result.ipList.map((a)=> ({ip:a, key:a}));
        setArrayList(newData);
      }).catch((response) => {
        setIsAuth(false);
        //message.error(customMessages.getMessage(response.responseCode));
      });
      
  }

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <Layout>
      <div className="profile-page profile-page--permission">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Profilim</h1>
          </div>
          <div className="content-wrapper">
          <ProfileMenu></ProfileMenu>
            <div className="profile-page__content">
              <h2 className="box__title">API IP İşlemleri</h2>
              {isAuthorized === false && (
                <InfoBox
                  type="warning"
                  content={
                    <p>
                      Bu işlemi yapmaya yetkiliniz yok. Sadece kullanıcı numarası ile OTP giriş yapıldığında yetkilendirme yapılabilir.
                    </p>
                  }
                />
              )}
              {isAuthorized === true && (
              <div className="table-wrapper">
                <div className="new-permission">
                  <UserWomen />
                  <div>
                    <p className="info-text--big">
                      Api entegrasyonu için yeni sabit IP tanımlayabilirsiniz
                    </p>
                    <Button
                      type="primary"
                      shape="round"
                      onClick={() => {
                        setNewPermissionModal(true);
                      }}
                    >
                      Yeni IP Tanımla
                    </Button>
                  </div>
                </div>
                <InfoBox
                type="warning"
                content={
                  <p>
                   Bu ekrandan Mesaj Üssü’ne API üzerinden giriş yapabileceğiniz ip numaralarını tanımlayabilirsiniz.
                  </p>
                }
              />
                <Modal
                  title="IP Bilgisi"
                  visible={newPermissionModal}
                  onCancel={() => setNewPermissionModal(false)}
                  footer={null}
                >
                  <Form form={form} name="form-ip"
                   onFinish={(values) => {
                    OnAddIp(values.newIp);
                    setNewPermissionModal(false);
                  }}>
                    <Form.Item
                      rules={[{ required: true }]}
                      name="newIp"
                      messageVariables={{ label: 'newIp' }}
                    >
                      <Input
                        info={
                          <span className="margin-top-spacing-xs block">
                            API'ye erişecek uygulamaya ait sabit IP bilgisini girmelisiniz.
                          </span>
                        }
                        type="text"
                        name="newIp"
                        label="IP"
                      />
                    </Form.Item>
                    
                    <div className="modal-action">
                      <Button
                        shape="round"
                        type="ghost"
                        onClick={() => setNewPermissionModal(false)}
                      >
                        Vazgeç
                      </Button>
                      <Button
                        key="confirm"
                        type="primary"
                        htmlType="submit"
                       
                      >
                        Ekle
                      </Button>
                    </div>
                  </Form>
                </Modal>
                
                  <Table
                    columns={columns }
                    scroll={isScreenLG ? { y: 610, x: 860 } : { y: 610 }}
                    dataSource={arrayList}
                    className="table--guide"
                    pagination={{ total: arrayList.length, position: ['bottomCenter'] }}
                  />
              </div>
               )}
            </div>

            
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};
export default IpList;
